import { bool, node, object, oneOfType, string } from 'prop-types';
import React, { memo } from 'react';
import styles from './style';

const InformationBox = (props) => {
  const { children, gradient, style } = props;

  const appliedStyle = gradient
    ? { ...styles.containerGradient, ...style }
    : { ...styles.container, ...style };

  return <div style={appliedStyle}>{children}</div>;
};

InformationBox.propTypes = {
  gradient: bool,
  style: object,
  children: oneOfType([node, string]),
};

InformationBox.defaultProps = {
  gradient: false,
  style: {},
  children: null,
};

export default memo(InformationBox);
